export { RibbonComponent } from '@shared/layout/ribbon/ribbon.component';



// WEBPACK FOOTER //
// ./src/app/shared/layout/ribbon/index.ts